<template>
  <div class="chat-message-container" ref="chatMessageContainer">
    <div class="msg-item" v-for="(item,index) in list" :key="index" :class="{kf:item.isKf}" v-if="item.msgBody">
      <img :src="item.isKf ? require('../../common/img/tykf_avatar.png') : require('../../common/img/yh_avatar.png')" alt="" class="avatar-img">
      <div class="right-box">
        <div class="time">
          <span>{{item.msgTime}}</span>
          <span class="nickname">{{item.fromNick || item.customerAccount}}</span>
        </div>
        <!-- 文本消息 -->
        <span class="msg-content" v-if="item.messageType === 'TIMTextElem'" v-html="item.msgBody[0].msgContent[0].text"></span>
        <!-- 图片消息 -->
        <el-image
          v-if="item.messageType === 'TIMImageElem'"
          class="msg-img"
          :src="item.imgUrl"
          :preview-src-list="[item.imgUrl]">
        </el-image>
        <!-- 文件消息 -->
        <el-tooltip class="item" effect="dark" :content="'点击去预览 ' + item.msgBody[0].msgContent[0].fileName" placement="top-start">
          <div class="file-message" v-if="item.messageType === 'TIMFileElem'" @click="toDownloadFile(item)">
            <i class="el-icon-folder"></i>
            <span class="file-name">{{item.msgBody[0].msgContent[0].fileName}}</span>
          </div>
        </el-tooltip>
        <!-- 视频消息 -->
        <video :src="item.videoUrl" v-if="item.messageType === 'TIMVideoFileElem'" controls></video>
        <!-- 自定义消息 - 课程卡片 -->
        <CourseSuspension :courseInfo="item.courseInfo" v-if="item.messageType === 'TIMCustomElem'" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // currentUserId 为当前客服id
  props: ['list', 'currentUserId'],
  watch: {
    list: {
      immediate: true,
      deep: true,
      handler: function () {
        this.list.forEach((item, index) => {
          // 是否是客服
          item.isKf = Boolean(item.fromAccountType === 2)
          // 消息类型
          item.messageType = item.msgBody[0].msgType
          let msgContent = item.msgBody[0].msgContent[0]
          // 文本消息
          item.messageText = msgContent.text
          // 图片消息
          item.imgUrl = msgContent.imageInfoArray && msgContent.imageInfoArray[0].url
          item.imgUrl = item.imgUrl && item.imgUrl.split('?Expires=')[0]
          // 自定义消息
          item.courseInfo = msgContent.date ? JSON.parse(msgContent.date) : {}
          // 文件消息
          item.fileName = msgContent.fileName
          item.fileUrl = msgContent.url
          item.fileUrl = item.fileUrl && item.fileUrl.split('?Expires=')[0]
          // 视频消息
          item.videoUrl = msgContent.videoUrl
          item.videoUrl = item.videoUrl && item.videoUrl.split('?Expires=')[0]
        })
        this.$nextTick(() => {
          this.scrollBottom()
        })
      }
    }
  },
  methods: {
    // 滚动到底部
    scrollBottom () {
      this.$refs.chatMessageContainer.scrollTop = 9999
    },
    // 预览文件消息
    toDownloadFile (item) {
      let url = item.fileUrl
      if (item.msgBody[0].msgContent[0].fileName.indexOf('.pdf') >= 0) {
        // pdf文件
        window.open(url)
      } else {
        // 非pdf文件
        window.open(
          'https://view.officeapps.live.com/op/view.aspx?src=' + url,
          '_blank'
        )
      }
    }
  }
}
</script>

<style lang="less" scoped>
.chat-message-container{
  max-height: 520px;
  overflow-y: auto;
  video{
    width: 200px;
    float: left;
  }
  .msg-item{
    overflow: hidden;
    margin-bottom: 14px;
    border-radius: 5px;
    .avatar-img{
      width: 50px;
      height: 50px;
      float: left;
    }
    .right-box{
      float: left;
      margin-left: 10px;
      .time{
        font-size: 12px;
        margin-bottom: 8px;
        .nickname{
          margin-left: 10px;
        }
      }
      .msg-content{
        display: inline-block;
        background-color: #f2f2f2;
        max-width: 600px;
        padding: 12px;
      }
      .msg-img{
        float: left;
        width: 200px;
        border: 3px solid #409eff;
        border-radius: 6px;
      }
      .file-message{
        display: flex;
        align-items: center;
        float: left;
        max-width: 230px;
        height: 70px;
        background-color: #5cacde;
        border-radius: 1px 8px 8px 8px;
        margin-top: 18px;
        padding: 0 10px;
        cursor: pointer;
        .el-icon-folder{
          font-size: 40px;
          color: #fff;
          margin-right: 7px;
        }
        .file-name{
          color: #fff;
          max-width: 150px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    video{
      width: 200px;
      border: 6px;
      border: 3px solid #409eff;
    }
  }
  .kf{
      video{
        float: right;
      }
      .avatar-img{
        float: right;
      }
      .time{
        text-align: right;
      }
      .right-box{
        float: right;
        margin-right: 10px;
        .msg-content{
          float: right;
          background-color: #e5f4ff;
        }
        .msg-img{
          float: right;
        }
        .file-message{
          float: right;
          border-radius: 8px 1px 8px 8px;
        }
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Public/MessageList.vue